export default function() {
  $('[data-navigation-dropdown]').change(event => window.location.href=event.target.value);
}

